import { Component, OnInit, inject, model, viewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

import { PrinterReferenceService, TmsFormlyService } from 'tms-web-shared';
import { BaseComponent, BaseEditFormModalComponent, IdDescription } from '../../../../tms-shared';
import { UserPrinterService, UserService } from '../../services';
import { UserPrinter } from '../../models';

@Component({
  selector: 'app-user-printers-create-modal',
  templateUrl: './user-printers-create-modal.component.html',
  styleUrl: './user-printers-create-modal.component.scss',
  imports: [BaseEditFormModalComponent],
})
export class UserPrintersCreateModalComponent extends BaseComponent implements OnInit {
  protected readonly userPrinterService = inject(UserPrinterService);
  private readonly printerReferenceService = inject(PrinterReferenceService);
  private readonly userService = inject(UserService);
  private readonly formlyService = inject(TmsFormlyService);

  private readonly form = viewChild(BaseEditFormModalComponent);

  public readonly id = model<string>();
  public readonly model = model<UserPrinter>();
  public readonly userId = model<string>();

  protected fields: FormlyFieldConfig[];

  private printers$: Observable<IdDescription[]>;

  ngOnInit() {
    this.getReferenceData();
    this.getFields();
  }

  private getReferenceData() {
    this.printers$ = this.printerReferenceService.get();
  }

  private getFields() {
    this.fields = [this.formlyService.select('printerId', $localize`Printer`, this.printers$, { required: true })];
  }

  saved() {
    this.userService.refreshDetails.next();
  }
}
